"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var componentName = 'buttons-collection';
exports.default = {
    name: componentName,
    functional: true,
    props: {
        kind: {
            type: String,
            default: 'single',
            validator: function (v) { return v == '' || /(single|double|multiple|vertical)/.test(v); }
        },
        forceAlign: {
            type: String,
            default: undefined,
            validator: function (v) { return v == '' || /(left|center|right)/.test(v); }
        }
    },
    render: function (h, ctx) {
        return h('div', { class: [wrapperClasses(ctx), ctx.data.staticClass] }, [
            ctx.slots().title && h('p', { class: 'buttons-collection__title wok--body-short-02' }, [
                ctx.slots().title
            ]),
            h('div', { class: 'buttons-collection' }, [
                ctx.slots().actions
            ])
        ]);
    }
};
function wrapperClasses(ctx) {
    var _a;
    return _a = {
            'buttons-collection__wrapper': true
        },
        _a["buttons-collection--" + ctx.props.kind] = ctx.props.kind,
        _a["buttons-collection--" + ctx.props.forceAlign] = ctx.props.forceAlign,
        _a;
}
